import axios from "axios";

export const fetchLastTaskByUser = ({ collaboratorId, owner }) => {
  const requestUrl = `/data/activityCollaborator`;

  let params = {
    collaboratorId: collaboratorId,
    owner: owner
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/activity.js